// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const WarningFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<mask
			id="WarningFilled_tsx__a"
			maskUnits="userSpaceOnUse"
			x={0.125}
			y={2.75}
			width={23}
			height={20}
			fill="#000"
		>
			<path fill="#fff" d="M.125 2.75h23v20h-23z" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.38 4.545a1.595 1.595 0 0 0-2.76 0L2.34 18.864c-.612 1.06.154 2.386 1.38 2.386h16.56c1.226 0 1.992-1.326 1.38-2.386L13.38 4.545Zm-.64 9.803a.74.74 0 1 1-1.48 0V8.435a.74.74 0 1 1 1.48 0v5.913Zm.248 3.206a.987.987 0 0 1-1.976 0 .987.987 0 0 1 1.976 0Z"
			/>
		</mask>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.38 4.545a1.595 1.595 0 0 0-2.76 0L2.34 18.864c-.612 1.06.154 2.386 1.38 2.386h16.56c1.226 0 1.992-1.326 1.38-2.386L13.38 4.545Zm-.64 9.803a.74.74 0 1 1-1.48 0V8.435a.74.74 0 1 1 1.48 0v5.913Zm.248 3.206a.987.987 0 0 1-1.976 0 .987.987 0 0 1 1.976 0Z"
			fill="#F8D22D"
		/>
		<path
			d="m10.62 4.545.866.501-.866-.5Zm2.76 0 .866-.5-.866.5ZM2.34 18.864l.867.5-.866-.5Zm19.32 0 .865-.5-.866.5ZM12 15.089v-1 1Zm.74-.74h-1 1Zm-1.48 0h-1 1Zm0-5.914h1-1Zm1.48 0h1-1Zm-1.254-3.389a.595.595 0 0 1 1.028 0l1.732-1.001c-.999-1.727-3.493-1.727-4.492 0l1.732 1.001Zm-8.28 14.318 8.28-14.318-1.732-1.001-8.279 14.318 1.732 1.001Zm.515.886a.59.59 0 0 1-.514-.886l-1.732-1c-1 1.729.252 3.886 2.246 3.886v-2Zm16.558 0H3.721v2h16.558v-2Zm.515-.886a.59.59 0 0 1-.515.886v2c1.994 0 3.246-2.157 2.246-3.887l-1.731 1.001Zm-8.28-14.318 8.28 14.318 1.73-1-8.278-14.32-1.732 1.002ZM12 16.089c.961 0 1.74-.78 1.74-1.74h-2a.26.26 0 0 1 .26-.26v2Zm-1.74-1.74c0 .96.779 1.74 1.74 1.74v-2a.26.26 0 0 1 .26.26h-2Zm0-5.914v5.913h2V8.435h-2ZM12 6.694c-.961 0-1.74.78-1.74 1.74h2a.26.26 0 0 1-.26.26v-2Zm1.74 1.74c0-.96-.779-1.74-1.74-1.74v2a.26.26 0 0 1-.26-.26h2Zm0 5.914V8.435h-2v5.913h2ZM12 19.54a1.987 1.987 0 0 0 1.988-1.986h-2v-.002l.001-.005a.01.01 0 0 1 .003-.004l.003-.002h.003L12 17.54v2Zm-1.988-1.986c0 1.099.893 1.986 1.988 1.986v-2h.002l.003.001.003.002.003.004.001.005v.002h-2ZM12 15.568a1.987 1.987 0 0 0-1.988 1.986h2v.002a.02.02 0 0 1-.001.005.012.012 0 0 1-.003.003s0 .002-.003.003H12v-2Zm1.988 1.986A1.987 1.987 0 0 0 12 15.568v2h-.002l-.003-.002a.01.01 0 0 1-.003-.002.01.01 0 0 1-.003-.003.02.02 0 0 1-.001-.005v-.002h2Z"
			fill="#000"
			mask="url(#WarningFilled_tsx__a)"
		/>
	</svg>
);
export default WarningFilled;
